import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadcrumbService, Breadcrumb } from 'angular-crumbs';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    Location, {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    }
  ]
})
export class AppComponent implements OnInit {
  constructor(private titleService: Title, private breadcrumbService: BreadcrumbService) {
  }
  ngOnInit(): void {
    this.breadcrumbService.breadcrumbChanged.subscribe(crumbs => {
      this.titleService.setTitle(this.createTitle(crumbs));
      this.loadChatwoot();
    });
  }
  onActivate(event){
    window.scroll(0,0);
  }
  private createTitle(routesCollection: Breadcrumb[]) {
    const title = 'WINPART by CFAO';
    const titles = routesCollection.filter((route) => route.displayName);

    if (!titles.length) { return title; }

    const routeTitle = this.titlesToString(titles);
    return `${title}${routeTitle}`;
  }

  private titlesToString(titles) {
    return titles.reduce((prev, curr) => {
      return `${prev} | ${curr.displayName}`;
    }, '');
  }

  loadChatwoot(): void {
    const script = document.createElement('script');
    script.src = "https://chatplatform.ywcdigital.com/packs/js/sdk.js";
    script.defer = true;
    script.async = true;
    script.onload = () => {
      (window as any).chatwootSDK.run({
        websiteToken: 'Ps2DJtiSssLw1E9Y7a4jwvdb',
        baseUrl: "https://chatplatform.ywcdigital.com",
        hidePoweredBy: true // Désactive la mention "Propulsé par Chatwoot"
      });
    };
    document.body.appendChild(script);
  }

}
